var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDailyCalls(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M195.7,152.6c-6.2-5.2-42.9-28.4-48.9-27.4c-2.9,0.5-5,2.9-10.9,9.9c-2.7,3.4-5.7,6.7-8.9,9.6 c-5.9-1.4-11.6-3.5-17-6.3C88.9,128.2,71.8,111.1,61.5,90c-2.8-5.4-4.9-11.1-6.3-17c3-3.2,6.2-6.2,9.6-8.9c7-5.9,9.4-8,9.9-10.9 c1.1-6.1-22.1-42.7-27.4-48.9c-2.1-2.6-4-4.3-6.6-4.3C33.3,0,0,41.2,0,46.6C0,47,0.7,90,54.9,145.1C110,199.3,153,200,153.4,200 c5.3,0,46.6-33.3,46.6-40.7C200,156.7,198.3,154.8,195.7,152.6L195.7,152.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M150,92.9h14.3c0-31.5-25.6-57.1-57.1-57.1V50C130.8,50,150,69.2,150,92.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF0",
    d: "M185.7,92.9H200C199.9,41.6,158.4,0.1,107.1,0v14.3C150.5,14.3,185.7,49.5,185.7,92.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyCalls);
export default __webpack_public_path__ + "static/media/daily-calls.aadfb6a897e5c50e66b7609e3727c548.svg";
export { ForwardRef as ReactComponent };